import axiosInstance, { get, post, put } from './axiosInstance';
import { isMockMode } from '../mocks/isMockMode';
import {
  createDocsDummyWithdrawals,
  createDocsDummyWithdrawalDetail,
} from '../mocks/withdrawalMocks';

const withdrawalApi = "/api/withdrawal";

export const filter = async (statusIds, date, orderId = null, pageSize = null, pageNumber = 1, sortDirection = 'DESC') => {
  let result = {
    isSuccess: false,
    data: null,
    errorCode: null
  };
  if (isMockMode()) {
    const statusOnlyProcessing = Array.isArray(statusIds) && statusIds.length === 1 && statusIds[0] === 8;
    let rows = statusOnlyProcessing ? [] : createDocsDummyWithdrawals(50, 'Success');
    if (orderId) {
      rows = rows.filter((item) => item.orderId.includes(orderId));
    }
    result.data = {
      withdrawals: rows,
      totalCount: rows.length,
    };
    result.isSuccess = true;
    return result;
  }
  try {
    result.data = await post(`${withdrawalApi}/filter`, {
      date,
      statusIds,
      orderId,
      pageSize,
      pageNumber,
      sortDirection
    });
    result.isSuccess = true;
  } catch (error) {
    result.errorCode = "ERR001";
  }
  return result;
};

export const getAllAvailable = async () => {
  let result = {
    isSuccess: false,
    data: null,
    errorCode: null
  };
  if (isMockMode()) {
    result.data = createDocsDummyWithdrawals(5, 'FAProcessing');
    result.isSuccess = true;
    return result;
  }
  try {
    result.data = await get(`${withdrawalApi}/available-withdrawals`);
    result.isSuccess = true;
  } catch (error) {
    result.errorCode = "ERR001";
  }
  return result;
};

export const getById = async (withdrawalId) => {
  let result = {
    isSuccess: false,
    data: null,
    errorCode: null
  };
  if (isMockMode()) {
    result.data = createDocsDummyWithdrawalDetail(withdrawalId);
    result.isSuccess = true;
    return result;
  }
  try {
    result.data = await get(`${withdrawalApi}/${withdrawalId}`);
    result.isSuccess = true;
  } catch (error) {
    result.errorCode = "ERR001";
  }
  return result;
};

export const grab = async (withdrawalId) => {
  let result = {
    isSuccess: false,
    data: null,
    errorCode: null
  };
  if (isMockMode()) {
    result.isSuccess = true;
    return result;
  }
  try{
    const response = await put(`${withdrawalApi}/${withdrawalId}/grab`);
    result.isSuccess = response.isSuccess;
    if(!result.isSuccess && response.errors){
      result.errorCode = response.errors[0].code;
    }
  }
  catch(error){
    console.error('Error grabbing withdrawal:', error);
  }
  return result;
};

export const cancel = async (withdrawalId) => {
  let result = {
    isSuccess: false,
    data: null,
    errorCode: null
  };
  if (isMockMode()) {
    result.isSuccess = true;
    return result;
  }
  try{
    const response = await put(`${withdrawalApi}/${withdrawalId}/cancel`);
    result.isSuccess = response.isSuccess;
    if(!result.isSuccess && response.errors){
      result.errorCode = response.errors[0].code;
    }
  }
  catch(error){
    console.error(error);
  }
  return result;
};

export const submit = async (withdrawalId, bankAccountId, attachmentList) => {
  let result = {
    isSuccess: false,
    errorCode: null
  };
  if (isMockMode()) {
    result.isSuccess = true;
    return result;
  }
  try {
    const formData = new FormData();

    // Append files to FormData
    attachmentList.forEach((file) => {
      formData.append('attachments', file);
    });

    // Add withdrawal ID
    formData.append('withdrawalId', withdrawalId);
    formData.append('bankAccountId', bankAccountId);

    // Send POST request
    const response = await axiosInstance.post(`${withdrawalApi}/${withdrawalId}/submit`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    result.isSuccess = response.data.isSuccess;
    if(!result.isSuccess && response.data.errors){
      result.errorCode = response.data.errors[0].code;
    }

  } catch (error) {
    console.error('Error submitting withdrawal:', error);
    result.errorCode = "ERR001";
  }
  return result;
};